/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IManageSceduledResourcesScope extends angular.IScope {
        model: models.ManageScheduledResourcesModel;
    }

    export class ManageScheduledResourcesController implements IController {
        scope: IManageSceduledResourcesScope;

        constructor(
            $scope: IManageSceduledResourcesScope,
            $routeParams: angular.route.IRouteParamsService,
            manageScheduledResourcesService: services.ManageScheduledResourcesService,
            manageSystemCodesService: services.ManageSystemCodesService,
            systemLevelService: services.SystemLevelService,
            deleteService: services.DeleteService,
            modalService: any)
        {
            this.scope = $scope;
            var id = $routeParams["id"];
            this.scope.model = new models.ManageScheduledResourcesModel(id, manageScheduledResourcesService, manageSystemCodesService, systemLevelService, deleteService, modalService);
        }
    }
}

warsApp.registerController('ManageScheduledResourcesController',
    [
        '$scope', '$routeParams', 'manageScheduledResourcesService', 'manageSystemCodesService',
        'systemLevelService', 'deleteService', 'ModalService'
    ]);